import React from "react";

/**
 * Renders the "Co-Founder · Furcare" gradient badge.
 *
 * Sizes:
 *  "sm"  — used inside comment headers (smallest)
 *  "md"  — used inside discussion post headers
 *  "lg"  — used on the profile page header (largest)
 */
const CoFounderBadge = ({ size = "sm" }) => {
  const sizeClasses = {
    sm: "text-[9px] px-1.5 py-0.5 gap-0.5",
    md: "text-[10px] px-2 py-0.5 gap-1",
    lg: "text-xs px-3 py-1 gap-1.5",
  };

  const starSize = {
    sm: 8,
    md: 9,
    lg: 11,
  };

  return (
    <span
      className={`inline-flex items-center font-bold rounded-full border border-amber-300
        bg-gradient-to-r from-amber-400 to-orange-500 text-white shadow-sm whitespace-nowrap
        ${sizeClasses[size]}`}
    >
      {/* Star icon inline SVG — avoids adding a lucide-react import in a tiny util */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={starSize[size]}
        height={starSize[size]}
        viewBox="0 0 24 24"
        fill="white"
        stroke="none"
        className="flex-shrink-0"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
      Co-Founder &middot; Furcare
    </span>
  );
};

export default CoFounderBadge;
